import type { ActionFields } from '@tribeplatform/gql-client/graphql'
import type {
  Action,
  MutationUnsetHomepageArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHomepageKey, getPageKey } from '../../utils/keys/space.key.js'

export const useUnsetHomepage = (options: {
  fields?: ActionFields
  useMutationOptions?: UseMutationOptions<
    Action,
    Error,
    MutationUnsetHomepageArgs
  >
}) => {
  const { fields = 'basic', useMutationOptions } = options
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, Error, MutationUnsetHomepageArgs>(
    input => client.spaces.unsetHomepage(input, fields),
    {
      onSuccess: (_, { type }) => {
        const pageKey = getPageKey({
          fields: 'default',
          variables: { path: '' },
        })

        const homePageKey = getHomepageKey({
          fields: 'default',
          variables: {
            type,
          },
        })

        queryClient.invalidateQueries(homePageKey)
        queryClient.invalidateQueries(pageKey)
      },
      ...useMutationOptions,
    },
  )
}
